import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";
// const Demo = (props) => (
//   <ScriptTag
//     type="text/javascript"
//     src="../../assets/js/scripts/forms/wizard-steps.js"
//   />
// );

// var fs = require("fs");
//locall
// import "./AddProduct.css";
import utils from "../../components/toastify/toastify";

const UpdateInformation = (props) => {
  const [get_main_error, get_main_loading, get_main_data, get_main_function] =
    useRequest({
      method: "get",
      url: "/get_main",
      //   isFunction: true,
    });

  console.log(get_main_data);

  const [top_menu_phone_Number, set_top_menu_phone_Number] = useState("");
  const [telegram, set_telegram] = useState("");
  const [youtube, set_youtube] = useState("");
  const [twitter, set_twitter] = useState("");
  const [aparat, set_aparat] = useState("");
  const [instagram, set_instagram] = useState("");
  const [instagram2, set_instagram2] = useState("");
  const [watsapp, set_watsapp] = useState("");
  const [myket, set_myket] = useState("");
  const [pwa, set_pwa] = useState("");
  const [google_play, set_google_play] = useState("");
  const [bazar, set_bazar] = useState("");
  const [sibapp, set_sibapp] = useState("");
  const [footer_title, set_footer_title] = useState("");
  const [footer_description, set_footer_description] = useState("");
  const [footer_phone_Number, set_footer_phone_Number] = useState("");
  const [footer_email, set_footer_email] = useState("");

  useEffect(() => {
    if (get_main_data) {
      const data = get_main_data.data;
      set_top_menu_phone_Number(data.top_menu_phone_Number);
      set_telegram(data.social_medias_link.telegram);
      set_youtube(data.social_medias_link.youtube);
      set_twitter(data.social_medias_link.twitter);
      set_aparat(data.social_medias_link.aparat);
      set_instagram(data.social_medias_link.instagram);
      set_instagram2(data.social_medias_link.instagram2);
      set_watsapp(data.social_medias_link.watsapp);
      set_myket(data.aplications_link.myket);
      set_pwa(data.aplications_link.pwa);
      set_google_play(data.aplications_link.google_play);
      set_bazar(data.aplications_link.bazar);
      set_sibapp(data.aplications_link.sibapp);
      set_footer_title(data.footer_title);
      set_footer_description(data.footer_description);
      set_footer_phone_Number(data.footer_phone_Number);
      set_footer_email(data.footer_email);
    }
  }, [get_main_data]);

  let history = useHistory();

  const [
    add_information_error,
    add_information_loading,
    add_information_data,
    add_information_function,
  ] = useRequest({
    method: "post",
    url: "/add_information",
    body: {
      top_menu_phone_Number,
      telegram,
      youtube,
      twitter,
      aparat,
      instagram,
      instagram2,
      watsapp,
      myket,
      pwa,
      google_play,
      bazar,
      sibapp,
      footer_title,
      footer_description,
      footer_phone_Number,
      footer_email,
    },
    isFunction: true,
  });

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">
                    افزودن منوی بالایی جدید
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">افزودن منوی بالایی جدید</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <h6>شماره موبایل بالای صفحه :</h6>
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="شماره موبایل بالای صفحه"
                                  value={top_menu_phone_Number}
                                  onChange={(e) =>
                                    set_top_menu_phone_Number(e.target.value)
                                  }
                                />
                              </div>
                              <h6>ایمیل پایین صفحه :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="ایمیل پایین صفحه"
                                value={footer_email}
                                onChange={(e) =>
                                  set_footer_email(e.target.value)
                                }
                              />
                              <h6>شماره موبایل پایین صفحه :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="شماره موبایل پایین صفحه"
                                value={footer_phone_Number}
                                onChange={(e) =>
                                  set_footer_phone_Number(e.target.value)
                                }
                              />
                              <h6>عنوان پایین صفحه :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="عنوان پایین صفحه"
                                value={footer_title}
                                onChange={(e) =>
                                  set_footer_title(e.target.value)
                                }
                              />
                              <h6>توضیحات پایین صفحه :</h6>

                              <textarea
                                class="form-control"
                                // id="basicTextarea"
                                rows="3"
                                placeholder="توضیحات پایین صفحه"
                                value={footer_description}
                                onChange={(e) =>
                                  set_footer_description(e.target.value)
                                }
                                style={{
                                  marginBottom: "10px",
                                }}
                              ></textarea>
                              <h6>لینک سیب اپ :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک سیب اپ"
                                value={sibapp}
                                onChange={(e) => set_sibapp(e.target.value)}
                              />
                              <h6>لینک بازار :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک بازار"
                                value={bazar}
                                onChange={(e) => set_bazar(e.target.value)}
                              />
                              <h6>لینک گوگل پلی :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک گوگل پلی"
                                value={google_play}
                                onChange={(e) =>
                                  set_google_play(e.target.value)
                                }
                              />
                              <h6>لینک pwa :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک pwa"
                                value={pwa}
                                onChange={(e) => set_pwa(e.target.value)}
                              />
                              <h6>لینک myket :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک myket"
                                value={myket}
                                onChange={(e) => set_myket(e.target.value)}
                              />
                              <h6>لینک watsapp :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک watsapp"
                                value={watsapp}
                                onChange={(e) => set_watsapp(e.target.value)}
                              />
                              <h6>لینک instagram :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک instagram"
                                value={instagram}
                                onChange={(e) => set_instagram(e.target.value)}
                              />
                              <h6>لینک instagram2 :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک instagram2"
                                value={instagram2}
                                onChange={(e) => set_instagram2(e.target.value)}
                              />
                              <h6>لینک aparat :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک aparat"
                                value={aparat}
                                onChange={(e) => set_aparat(e.target.value)}
                              />
                              <h6>لینک twitter :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک twitter"
                                value={twitter}
                                onChange={(e) => set_twitter(e.target.value)}
                              />
                              <h6>لینک youtube :</h6>

                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک youtube"
                                value={youtube}
                                onChange={(e) => set_youtube(e.target.value)}
                              />
                              <h6>لینک telegram :</h6>
                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="لینک telegram"
                                value={telegram}
                                onChange={(e) => set_telegram(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  var $white = "#fff";
                  $.blockUI({
                    message:
                      '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

                    // timeout: 2000, //unblock after 2 seconds
                    overlayCSS: {
                      backgroundColor: $white,
                      opacity: 0.8,
                      cursor: "wait",
                    },
                    css: {
                      border: 0,
                      padding: 0,
                      backgroundColor: "transparent",
                    },
                  });
                  add_information_function()
                    .then(() => {
                      history.push("/dashboard/updateInformation");
                      $.unblockUI();
                    })
                    .catch(() => {
                      utils.showAlert("خطایی به وجود آمده است", "error");
                      $.unblockUI();
                    });
                }}
                style={{
                  marginTop: "-2rem",
                  marginRight: "25px",
                  width: "fit-content",
                }}
                type="button"
                class="btn btn-success mr-1 mb-1 "
              >
                ذخیره تغییرات
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { UpdateInformation };
